import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e15e5af"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid": "step-addressDetails",
  class: "container"
}
const _hoisted_2 = { class: "container__standard-header" }
const _hoisted_3 = { class: "row custom-select-wrapper" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "search-instructions" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "row row--numbers-of-house-flat" }
const _hoisted_10 = { class: "row row--numbers-of-house-flat" }
const _hoisted_11 = { class: "row custom-select-wrapper row--correspondence-method" }
const _hoisted_12 = {
  key: 0,
  class: "row correspondence-info"
}
const _hoisted_13 = {
  key: 1,
  class: "row row-feeds-and-commisions"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 2,
  class: "row row--address-for-correspondence"
}
const _hoisted_16 = { class: "row custom-select-wrapper" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "row row__correspondence-information-house" }
const _hoisted_21 = { class: "row row__correspondence-information-house" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheCountrySelect = _resolveComponent("TheCountrySelect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_FieldMask = _resolveComponent("FieldMask")!
  const _component_AutocompleteField = _resolveComponent("AutocompleteField")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.addressHeader`)), 1),
    _createElementVNode("form", {
      onSubmit: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.blockSendForm && _ctx.blockSendForm(...args)))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheCountrySelect, {
          name: "country",
          "default-value": _ctx.defaultCountry,
          "country-list": _ctx.countries,
          label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.homeCountry`),
          placeholder: 
                        _ctx.$t(`${_ctx.TRANSLATION_KEY}.chooseCountryPlaceholder`)
                    ,
          class: "custom-select",
          "country-disable": _ctx.isDefaultCountrySelected,
          onSelectedCountry: _cache[0] || (_cache[0] = ($event: any) => (_ctx.formData.country = $event))
        }, null, 8, ["default-value", "country-list", "label", "placeholder", "country-disable"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.searchAddress`)), 1),
        _createVNode(_component_Field, {
          key: "searchAddressOther",
          modelValue: _ctx.formData.searchAddress,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.searchAddress = $event)),
          type: "text",
          name: "searchAddress",
          placeholder: 
                        _ctx.$t(`${_ctx.TRANSLATION_KEY}.searchAddressPlaceholder`)
                    ,
          "cy-data": "searchAddress",
          "is-validated": false,
          "street-filter": true,
          onFocus: _ctx.populateDataForm
        }, null, 8, ["modelValue", "placeholder", "onFocus"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Field, {
          key: "postalCodeOther",
          modelValue: _ctx.formData.postalCode,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.postalCode = $event)),
          type: "text",
          name: "postalCode",
          placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.postcodePlaceholder`),
          "cy-data": "zip",
          onKeyup: _ctx.keyupEvent
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.postcode`)), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Field, {
          modelValue: _ctx.formData.city,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.city = $event)),
          type: "text",
          name: "city",
          placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.cityPlaceholder`),
          "cy-data": "city"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.city`)), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Field, {
          modelValue: _ctx.formData.street,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.street = $event)),
          type: "text",
          name: "street",
          placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.streetPlaceholder`),
          "cy-data": "street",
          "street-filter": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.street`)), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Field, {
          modelValue: _ctx.formData.buildingNumber,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.buildingNumber = $event)),
          type: "text",
          name: "buildingNumber",
          placeholder: 
                        _ctx.$t(`${_ctx.TRANSLATION_KEY}.houseNumberPlaceholder`)
                    ,
          "cy-data": "building-number"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.houseNumberPlaceholder`)), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Field, {
          modelValue: _ctx.formData.apartmentNumber,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.apartmentNumber = $event)),
          type: "text",
          name: "apartmentNumber",
          placeholder: 
                        _ctx.$t(`${_ctx.TRANSLATION_KEY}.flatNumberPlaceholder`)
                    ,
          "cy-data": "apartment-number"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.flatNumberPlaceholder`)), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Select, {
          "ref-value": "correspondenceMethod",
          "item-list": _ctx.correspondenceMethodArray,
          "default-value": String(_ctx.CorrespondenceMethod.EMAIL),
          "model-value": _ctx.formData.correspondenceChoice,
          placeholder: 
                        _ctx.$t(`${_ctx.TRANSLATION_KEY}.chooseCorrespondenceMethod`)
                    ,
          label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.correspondenceMethod`),
          name: "correspondenceChoice",
          "cy-data": "correspondence-choice",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.correspondenceChoice = $event))
        }, null, 8, ["item-list", "default-value", "model-value", "placeholder", "label"])
      ]),
      (_ctx.isPaperCorrespondenceSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.correspondenceMethodTwoLabel1`)), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.correspondenceMethodTwoLabel2`)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isPaperCorrespondenceSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("a", {
              href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.feesAndCommisionsTableFile`),
              rel: "noopener",
              target: "_blank"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.feesAndCommisionsTable`)), 1)
            ], 8, _hoisted_14)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isPaperCorrespondenceSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_CheckBox, {
              modelValue: _ctx.formData.contactAddress,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.contactAddress = $event)),
              name: "contactAddress",
              "cy-data": "has-different-contact-address"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.correspondenceAddress`)), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "smooth" }, {
        default: _withCtx(() => [
          (
                        _ctx.isPaperCorrespondenceSelected && _ctx.formData.contactAddress
                    )
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "row row--information-about-correspondence-address",
                style: _normalizeStyle({ maxHeight: _ctx.maxCorrespondenceHeight + 'px' })
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Select, {
                    "item-list": _ctx.countries,
                    name: "contactCountry",
                    placeholder: 
                                _ctx.$t(
                                    `${_ctx.TRANSLATION_KEY}.chooseCountryPlaceholder`
                                )
                            ,
                    label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.homeCountry`),
                    "cy-data": "contact-country",
                    flags: true,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (
                                _ctx.formData.contactCountry = $event
                            ))
                  }, null, 8, ["item-list", "placeholder", "label"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.formData.contactCountry !== 'PL')
                    ? (_openBlock(), _createBlock(_component_Field, {
                        key: "contactPostalCodeOther",
                        modelValue: _ctx.formData.contactPostalCode,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.contactPostalCode = $event)),
                        type: "text",
                        name: "contactPostalCode",
                        placeholder: 
                                _ctx.$t(
                                    `${_ctx.TRANSLATION_KEY}.correspondencePostcodePlaceholder`
                                )
                            ,
                        "cy-data": "contact-zip"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t(
                                        `${_ctx.TRANSLATION_KEY}.correspondencePostcode`
                                    )), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"]))
                    : (_openBlock(), _createBlock(_component_FieldMask, {
                        key: "contactPostalCodePL",
                        modelValue: _ctx.formData.contactPostalCode,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.contactPostalCode = $event)),
                        type: "text",
                        name: "contactPostalCode",
                        pattern: "##-###",
                        placeholder: 
                                _ctx.$t(
                                    `${_ctx.TRANSLATION_KEY}.correspondencePostcodePlaceholder`
                                )
                            ,
                        "cy-data": "zip",
                        onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.requestCorrespondenceCity($event)))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t(
                                        `${_ctx.TRANSLATION_KEY}.correspondencePostcode`
                                    )), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"]))
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_AutocompleteField, {
                    modelValue: _ctx.formData.contactCity,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formData.contactCity = $event)),
                    type: "text",
                    name: "contactCity",
                    placeholder: 
                                _ctx.$t(
                                    `${_ctx.TRANSLATION_KEY}.correspondenceCityPlaceholder`
                                )
                            ,
                    "cy-data": "contact-city",
                    "item-list": _ctx.correspondenceCityItemList,
                    "override-old-value": true,
                    onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.getCorrespondenceStreets()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.correspondenceCity`)), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "item-list"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_AutocompleteField, {
                    modelValue: _ctx.formData.contactStreet,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formData.contactStreet = $event)),
                    type: "text",
                    name: "contactStreet",
                    placeholder: 
                                _ctx.$t(
                                    `${_ctx.TRANSLATION_KEY}.correspondenceStreetPlaceholder`
                                )
                            ,
                    "cy-data": "contact-street",
                    "item-list": _ctx.correspondenceStreetItemList,
                    "is-street": true
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(
                                        `${_ctx.TRANSLATION_KEY}.correspondenceStreet`
                                    )), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "item-list"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_Field, {
                    modelValue: _ctx.formData.contactBuildingNumber,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formData.contactBuildingNumber = $event)),
                    type: "text",
                    name: "contactBuildingNumber",
                    placeholder: 
                                _ctx.$t(`${_ctx.TRANSLATION_KEY}.houseNumberPlaceholder`)
                            ,
                    "cy-data": "contact-building-number"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(
                                        `${_ctx.TRANSLATION_KEY}.houseNumberPlaceholder`
                                    )), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_Field, {
                    modelValue: _ctx.formData.contactApartmentNumber,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formData.contactApartmentNumber = $event)),
                    type: "text",
                    name: "contactApartmentNumber",
                    placeholder: 
                                _ctx.$t(`${_ctx.TRANSLATION_KEY}.flatNumberPlaceholder`)
                            ,
                    "cy-data": "contact-apartment-number"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(
                                        `${_ctx.TRANSLATION_KEY}.flatNumberPlaceholder`
                                    )), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ])
              ], 4))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_SubmitButton, {
        action: _ctx.Action.ADDRESS_DETAILS,
        "button-value": _ctx.$t(`${_ctx.TRANSLATION_KEY}.next`),
        data: _ctx.formData,
        "data-testid": "btn-addressDetails-nextStep",
        class: "button button--submit",
        disabled: 
                    !(_ctx.formData.country &&
                    _ctx.formData.postalCode &&
                    _ctx.formData.city &&
                    _ctx.formData.street &&
                    _ctx.formData.buildingNumber &&
                    _ctx.formData.contactAddress === false
                        ? true
                        : _ctx.formData.contactCountry &&
                          _ctx.formData.contactPostalCode &&
                          _ctx.formData.contactCity &&
                          _ctx.formData.contactStreet &&
                          _ctx.formData.contactBuildingNumber)
                ,
        onClick: _cache[18] || (_cache[18] = 
                    () =>
                        _ctx.amplitudeSendEvent(
                            _ctx.AmplitudeAnalyticsEvents.address.ADDRESS_CONTINUE
                        )
                )
      }, null, 8, ["action", "button-value", "data", "disabled"])
    ], 32)
  ]))
}